// Single source for environment-derived config (URLs etc.).
//
// WHY THIS EXISTS: the builder frontend is a CRA bundle that is BUILT ONCE and
// PROMOTED across environments (registry.getzino.in). `process.env.REACT_APP_*`
// is baked into the bundle at build time, so a promoted (sandbox-built) image
// carries sandbox URLs into dev/studio. To decouple, each environment serves
// /runtime-config.js (mounted from a per-namespace ConfigMap) which sets
// window.__RUNTIME_CONFIG__ before the bundle evaluates.
//
// ALWAYS read env-derived URLs through runtimeEnv() — never read
// process.env.REACT_APP_* directly in app code. A raw read silently points the
// promoted binary at whatever env built it (this is how the dev-deploy-hits-
// sandbox bug happened).
//
// CRA GOTCHA: webpack DefinePlugin only substitutes LITERAL `process.env.REACT_APP_X`
// references. A dynamic `process.env[key]` is NOT replaced and resolves to
// undefined at runtime. So the build-time fallbacks below must be literal reads,
// collected into a map the helper can look up by key.
const BAKED = {
  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  REACT_APP_AI_BUILDER_API_URL: process.env.REACT_APP_AI_BUILDER_API_URL,
  REACT_APP_AI_EMPLOYEE_URL: process.env.REACT_APP_AI_EMPLOYEE_URL,
  REACT_APP_PIPELINE_AI_URL: process.env.REACT_APP_PIPELINE_AI_URL,
  REACT_APP_PIPELINE_API_URL: process.env.REACT_APP_PIPELINE_API_URL,
  REACT_APP_RETRIEVAL_SERVICE_URL: process.env.REACT_APP_RETRIEVAL_SERVICE_URL,
  REACT_APP_MOCK_SERVER_URL: process.env.REACT_APP_MOCK_SERVER_URL,
  REACT_APP_PIPELINE_ENGINE_URL: process.env.REACT_APP_PIPELINE_ENGINE_URL,
  REACT_APP_QA_SERVICE_URL: process.env.REACT_APP_QA_SERVICE_URL,
  REACT_APP_SUPPORT_SERVICE_URL: process.env.REACT_APP_SUPPORT_SERVICE_URL,
};

/**
 * Resolve an env-derived value: runtime config first, then the build-time-baked
 * value, then an optional caller fallback.
 * @param {string} key e.g. "REACT_APP_API_BASE_URL"
 * @param {string} [fallback] used when neither runtime nor baked value is set
 * @returns {string|undefined}
 */
export const runtimeEnv = (key, fallback) => {
  const rc = (typeof window !== "undefined" && window.__RUNTIME_CONFIG__) || {};
  return rc[key] || BAKED[key] || fallback;
};

export default runtimeEnv;
